define(["data/config"], function(config) {
    var bind = function($loader) {
        $loader.addClass("is_set");

        var last = 0;
        var block = false;
        var $window = $(window);
        var $document = $(document);
        var timeout = function() {};
        var request = undefined;

        if ($loader.parents(".u_scrolls").length > 0) {
            var $container = $loader.parents(".u_scrolls");
            var bottom = $container[0].scrollHeight - $loader.position().top;
            var getTop = function() {
                return $container[0].scrollHeight - bottom;
            };
        } else {
            var $container = $window;
            var bottom = $document.height() - $loader.offset().top;
            var getTop = function() {
                return $document.height() - bottom - $container.height();
            };
        }
        var top = getTop();

        var check = function() {
            if (block === true) {
                return;
            }
            if (top - $container.scrollTop() < 500) {
                block = true;
                $loader.data("fetch")();
            }
        };
        var fetch = function() {
            $loader.show();
            var $target = $loader;
            if ($loader.data("loaderTarget")) {
                $target = $($loader.data("loaderTarget"));
            }

            if (
                !$loader.data("loaderFrom") ||
                $loader.find(".is_drained").length > 0
            ) {
                return;
            }

            if (
                typeof request === "object" &&
                request.readyState &&
                request.readyState !== 4 &&
                request.abort
            ) {
                request.abort();
            }

            request = $.get(config.baseUrl + $loader.data("loaderFrom"), {
                page: $loader.data("page")
            }).done(function(html) {
                if (html) {
                    $(html)
                        .addClass("js_loaderInject")
                        .appendTo($target);
                    setTimeout(function() {
                        $(window)
                            .trigger(config.events.significantDomChange)
                            .trigger("ajaxInjected");
                    }, 1);
                    if (
                        !$(html).hasClass("is_drained") &&
                        $(html).find(".is_drained").length === 0
                    ) {
                        // Fetch next page
                        top = getTop();
                        var skip = 1;
                        if (
                            $(html)
                                .first()
                                .data("skip")
                        ) {
                            skip = +$(html).data("skip");
                        }
                        $loader.data("page", $loader.data("page") + skip);
                        $loader.trigger("contentLoaded");
                        block = false;
                        check();
                    } else {
                        $loader.trigger("contentLoaded");
                        //$loader.hide();
                        block = true;
                    }
                } else {
                    $loader.trigger("contentLoaded");
                }
            });
        };
        var wipe = function() {
            $loader.show();
            $loader.data("page", 1);
            block = false;
            if ($loader.prev().hasClass("js_loaderInject")) {
                $loader.prev().remove();
                wipe();
            }
        };

        if (!$loader.attr("data-page")) {
            $loader.data("page", 1);
        }
        $loader.data("check", check);
        $loader.data("fetch", fetch);
        $loader.data("wipe", wipe);
        //fetch();
        $container.on("scroll.loader", function() {
            check();
        });
        $(window).on(
            config.events.significantDomChange + " ajaxInjected",
            function() {
                top = getTop();
            }
        );

        $container.trigger("scroll.loader");
    };

    return {
        name: "loader",
        apply: bind
    };
});
